import { useFormikContext } from "formik";
import React from "react";
import TextArea from "../../../../../components/form/TextArea";
import { SourceEnum } from "../../../../../enums/template";
import { Template } from "../../../../../models";
import {
  getMediaLinkPlaceholder,
  getMediaLinkTooltip,
} from "../../../../../utils";

export default function CustomTextInput() {
  const { values, errors, setFieldValue } =
    useFormikContext<Partial<Template>>();
  return (
    <TextArea
      label="Transcript"
      name="textBlock"
      value={values?.textBlock ?? ""}
      tooltip={getMediaLinkTooltip(SourceEnum.TEXT_BLOCK)}
      placeholder={getMediaLinkPlaceholder(SourceEnum.TEXT_BLOCK)}
      maxLength={10000}
      maxHeight={300}
      errorMessage={errors.textBlock}
      errorPosition="bottom-left"
      showCharacterCount={true}
      onChange={({ target: { value } }) => setFieldValue("textBlock", value)}
      onBlur={({ target: { value } }) => {
        setFieldValue("textBlock", value.trim());
      }}
    />
  );
}
